export const platformVersion = '^16.0.1';
